/**
 * Partner Service Layer
 *
 * Provides partner logos data with mock/API toggle.
 * Controlled by REACT_APP_USE_MOCK_DATA environment variable.
 */

// Note: partner logos are static marketing content — no /api/partners
// endpoint exists on the BE. Always returns the curated list below.
// When partners become editable from an admin / CMS, re-introduce the
// apiClient call + a corresponding BE endpoint.

export interface Partner {
  id: number;
  name: string;
  logoUrl: string;
}

// Mock data for development
const mockPartners: Partner[] = [
  { id: 1, name: 'Partner 1', logoUrl: 'https://via.placeholder.com/200x80?text=Partner+1' },
  { id: 2, name: 'Partner 2', logoUrl: 'https://via.placeholder.com/200x80?text=Partner+2' },
  { id: 3, name: 'Partner 3', logoUrl: 'https://via.placeholder.com/200x80?text=Partner+3' },
];

/**
 * Fetch partners. Always returns the curated static list — no BE endpoint
 * exists yet. Promise wrapper kept so call sites stay async and the
 * eventual switch to a real fetch is a single-file change.
 */
export const fetchPartners = async (): Promise<Partner[]> => {
  return mockPartners;
};
